module.exports = __webpack_public_path__ + "img/bus.978730d4.svg";